import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { Box, Link } from '@mui/material';
import { stripCitationTokens } from '../../features/narrative-citations/parseCitations';
import { rehypeSanitizeCitationTokens } from '../../features/narrative-citations/rehypeSanitizeCitationTokens';
import { markdownProseSx } from './markdownProseSx';

interface MarkdownContentProps {
  content: string;
}

export const MarkdownContent: React.FC<MarkdownContentProps> = ({ content }) => {
  // Generic markdown surfaces cannot follow citations. Hide both valid and
  // malformed private markers before rendering so they never appear as glyphs.
  const processedContent = stripCitationTokens(content).replace(/\\n/g, '\n');

  return (
    <Box sx={markdownProseSx}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        rehypePlugins={[rehypeSanitizeCitationTokens]}
        components={{
          a: ({ href, children }) => (
            <Link
              href={stripCitationTokens(href)}
              target="_blank"
              rel="noopener noreferrer"
            >
              {children}
            </Link>
          ),
        }}
      >
        {processedContent}
      </ReactMarkdown>
    </Box>
  );
};
